import { cn } from "@/lib/utils";

interface PageHeadingProps {
  children: React.ReactNode;
  className?: string;
}

export function PageHeading({ children, className }: PageHeadingProps) {
  return (
    <div className="max-w-5xl mx-auto">
      <h1 className={cn("text-3xl font-semibold p-6", className)}>
        {children}
      </h1>
    </div>
  );
}
